<template>
  <v-menu
    ref="birthdayMenu"
    v-model="birthdayMenu"
    :close-on-content-click="false"
    :return-value.sync="stringBirthday"
    >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="stringBirthday"
        label="生年月日"
        prepend-icon="event"
        readonly
        v-on="on"
        v-validate="'required'"
        data-vv-name="birthday"
        data-vv-as="生年月日"
        required>
      </v-text-field>
    </template>
      <v-date-picker
        v-model="stringBirthday"
        no-title
        scrollable
        width="400">
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="birthdayMenu = false">Cancel</v-btn>
        <v-btn text color="primary" @click="$refs.birthdayMenu.save(stringBirthday)">OK</v-btn>
      </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "BirthdayPicker",

  props: {
    value: Date
  },
  data() {
    return {
      birthdayMenu: null,
    }
  },
  methods: {
    birthdayToString() {
      const t = this.birthday.getFullYear()
      const m = this.birthday.getMonth() + 1
      const d = this.birthday.getDate()
      return t + "-" + m + "-" + d
    },
    updateValue (diff) {
      this.$emit("input", { ...this.value, ...diff })
    }
  },
  computed: {
    birthday: {
      get () {
        return this.value
      },
      set (birthday) {
        this.$emit('input', birthday)
      }
    },
    stringBirthday:{
      get () {
        return this.birthdayToString()
      },
      set (stringBirthday) {
        this.birthday = new Date(stringBirthday)
      }
    }
  }
}
</script>
